import React, { PureComponent } from 'react'
import { shape, string } from 'prop-types'
import { createComponent } from '@ycos/fela'
import { Prefix, Text, LabelLink } from '@ycos/primitives'

const InfoFieldWrapper = createComponent('InfoFieldWrapper', () => ({
  textAlign: 'left'
}))

class InfoField extends PureComponent {
  static layoutVariant = 'isc-informational-field'

  render() {
    const { teaserTitle, teaserTextPlain, target } = this.props.item

    return (
      <InfoFieldWrapper>
        {teaserTitle && <Prefix>{teaserTitle}</Prefix>}
        {teaserTextPlain &&
          teaserTextPlain
            .replace(/^\s+|\s+$/g, '')
            .split('\n')
            .map((text, i) => <Text key={`${i}:${teaserTitle || 'infoField'}`}>{text}</Text>)}
        {target?.teaserTitle && target?.href && (
          <LabelLinkStyled href={target.href} target="_blank" rel="noopener">
            {target.teaserTitle}
          </LabelLinkStyled>
        )}
      </InfoFieldWrapper>
    )
  }
}

InfoField.propTypes = {
  item: shape({
    teaserTextPlain: string,
    teaserTitle: string,
    target: shape({
      type: string,
      href: string,
      teaserTitle: string
    })
  })
}

InfoField.defaultProps = {
  item: {}
}

const LabelLinkStyled = createComponent(
  'LabelLink',
  ({ theme }) => ({
    paddingTop: `${2 * theme.spacingMultiplier}px`,
    display: 'inline-block'
  }),
  LabelLink,
  ['rel']
)

export default InfoField
